import { UntypedFormGroup, ValidationErrors } from '@angular/forms';

export function requireTrue(control: UntypedFormGroup): ValidationErrors | null {
  const hasError = control.value ? !control.value : true;
  return hasError ? {requireTrue: true} : null;
}
